/* Orvani Timepieces — Theme JS */

document.addEventListener('DOMContentLoaded', () => {

  // Scroll to contact form after successful submission
  if (window.location.search.includes('contact%5Bposted_successfully%5D=true')) {
    const anchor = document.getElementById('contact-form-anchor');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Header scroll behavior
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile nav
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');

  if (menuBtn && mobileNav) {
    const closeNav = () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
      menuBtn.setAttribute('aria-expanded', 'false');
    };
    menuBtn.addEventListener('click', () => {
      const isOpen = mobileNav.classList.contains('open');
      if (isOpen) { closeNav(); return; }
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
      menuBtn.setAttribute('aria-expanded', 'true');
    });
    mobileNav.addEventListener('click', (e) => { if (e.target === mobileNav) closeNav(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeNav(); });
  }

  // Accordion
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      // Close all siblings
      item.closest('.accordion').querySelectorAll('.accordion-item.open').forEach(i => {
        i.classList.remove('open');
        i.querySelector('.accordion-content').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        const content = item.querySelector('.accordion-content');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // Product gallery thumbnails
  const galleryMain = document.querySelector('#product-gallery-main');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (galleryMain && thumb.dataset.fullSrc && thumb.dataset.fullSrc !== galleryMain.src) {
        galleryMain.classList.add('gallery-switching');
        setTimeout(() => {
          galleryMain.src = thumb.dataset.fullSrc;
          galleryMain.srcset = '';
          galleryMain.onload = () => galleryMain.classList.remove('gallery-switching');
        }, 180);
      }
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Quantity buttons
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.product-quantity').querySelector('.qty-input');
      const val = parseInt(input.value, 10) || 1;
      if (btn.dataset.action === 'minus' && val > 1) input.value = val - 1;
      if (btn.dataset.action === 'plus') input.value = val + 1;
    });
  });

  // Image protection — disable right-click, drag, and long-press save
  document.querySelectorAll('img').forEach(img => {
    img.addEventListener('contextmenu', e => e.preventDefault());
    img.addEventListener('dragstart', e => e.preventDefault());
  });
  // Re-apply on dynamic content (e.g. gallery thumb swap)
  document.addEventListener('contextmenu', e => {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    const initReveal = () => {
      document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(el => {
        if (window.Shopify && window.Shopify.designMode) {
          el.classList.add('is-revealed');
        } else {
          revealObserver.observe(el);
        }
      });
    };

    initReveal();
    document.addEventListener('shopify:section:load', initReveal);
  }

});
